<div class="modal-close"  (click)="closeModal()">
    <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon><span >{{ "btn:close" | translate }}</span>
</div>

<div class="modal-header">
    <h4 class="modal-title">{{"course:add:modal:title:reviews"|translate}}</h4>
</div>

<div class="modal-body">
  <div class="container py-4">
    <app-search-input
      [inputPlaceholder]="'Search review'"
      [actualSearch]="this.searchText"
      [loading]="loading"

      [searchText]="'Search'"
      (searchEvent)="search($event)"
      *ngIf="actualTab=='allCourse'"
    ></app-search-input>

    <div *ngIf="loading" class="row max-heigth">
      <div class="row loadingCenter">
          <app-loading-icon ></app-loading-icon>
      </div>
    </div>

    <div *ngIf="!loading" class="row justify-content-center max-heigth list-overflow">
      <div  *ngFor="let review of reviews" class="row justify-content-center">
        <div class="col-xl-12 p-0" style="margin-right: 4px;">
          <app-review-list-card [review]="review" [itemSelect]="itemSelect" (selectItem)="selectItem($event)" (deleteReview)="deletedItem($event)" class="p-0"></app-review-list-card>
        </div>
      </div>

      <div *ngIf="!loading&&reviews.length==0">There are no reviews to display</div>
    </div>
  </div> 
</div>

<div class="modal-footer">
  <div class="form-group clearfix">
    <button (click)="sendData()" [disabled]="itemSelect==''"  type="button" role="tab" class="btn btn-primary btn-create modal-btn-width float-right ms-2 fs-15">
      <fa-icon class="ms-2" [icon]="faCircleNorch" *ngIf="addLoading"  [spin]="true"></fa-icon>
      {{ onLesson ? 'Add review' : "course:add:modal:title" | translate}}
    </button>
  </div>
</div>

